import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';


const InvoiceFilters = ({ language, filters, onFilterChange, onReset }) => {
  const statusOptions = [
    { 
      value: 'all', 
      label: language === 'fr' ? 'Tous les statuts' : language === 'ar' ? 'جميع الحالات' : 'All Statuses' 
    },
    { 
      value: 'paid', 
      label: language === 'fr' ? 'Payé' : language === 'ar' ? 'مدفوع' : 'Paid' 
    },
    { 
      value: 'pending', 
      label: language === 'fr' ? 'En attente' : language === 'ar' ? 'قيد الانتظار' : 'Pending' 
    },
    { 
      value: 'overdue', 
      label: language === 'fr' ? 'En retard' : language === 'ar' ? 'متأخر' : 'Overdue' 
    },
    { 
      value: 'partial', 
      label: language === 'fr' ? 'Partiellement payé' : language === 'ar' ? 'مدفوع جزئيًا' : 'Partially Paid' 
    }
  ];

  const billingTypeOptions = [
    { 
      value: 'all', 
      label: language === 'fr' ? 'Tous les types' : language === 'ar' ? 'جميع الأنواع' : 'All Types' 
    },
    { 
      value: 'flat_fee', 
      label: language === 'fr' ? 'Tarif forfaitaire' : language === 'ar' ? 'رسوم ثابتة' : 'Flat Fee' 
    },
    { 
      value: 'hourly', 
      label: language === 'fr' ? 'Tarif horaire' : language === 'ar' ? 'رسوم بالساعة' : 'Hourly Rate' 
    },
    { 
      value: 'per_hearing', 
      label: language === 'fr' ? 'Par audience' : language === 'ar' ? 'لكل جلسة' : 'Per Hearing' 
    }
  ];

  const clientOptions = [
    { 
      value: 'all', 
      label: language === 'fr' ? 'Tous les clients' : language === 'ar' ? 'جميع العملاء' : 'All Clients' 
    },
    { 
      value: 'client_1', 
      label: language === 'fr' ? 'Fatima El Amrani' : language === 'ar' ? 'فاطمة العمراني' : 'Fatima El Amrani' 
    },
    { 
      value: 'client_2', 
      label: language === 'fr' ? 'Mohammed Benali' : language === 'ar' ? 'محمد بنعلي' : 'Mohammed Benali' 
    },
    { 
      value: 'client_3', 
      label: language === 'fr' ? 'Société TechMaroc SARL' : language === 'ar' ? 'شركة تك مغرب ذ.م.م' : 'TechMaroc SARL Company' 
    },
    { 
      value: 'client_4', 
      label: language === 'fr' ? 'Amina Tazi' : language === 'ar' ? 'أمينة التازي' : 'Amina Tazi' 
    }
  ];

  const labels = {
    status: language === 'fr' ? 'Statut' : language === 'ar' ? 'الحالة' : 'Status',
    billingType: language === 'fr' ? 'Type de facturation' : language === 'ar' ? 'نوع الفوترة' : 'Billing Type',
    client: language === 'fr' ? 'Client' : language === 'ar' ? 'العميل' : 'Client',
    dateFrom: language === 'fr' ? 'Date de début' : language === 'ar' ? 'تاريخ البداية' : 'Date From',
    dateTo: language === 'fr' ? 'Date de fin' : language === 'ar' ? 'تاريخ النهاية' : 'Date To',
    search: language === 'fr' ? 'Rechercher par numéro de facture' : language === 'ar' ? 'البحث برقم الفاتورة' : 'Search by invoice number',
    reset: language === 'fr' ? 'Réinitialiser' : language === 'ar' ? 'إعادة تعيين' : 'Reset Filters'
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6 mb-4 md:mb-6">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <Select
          label={labels?.status}
          options={statusOptions}
          value={filters?.status}
          onChange={(value) => onFilterChange('status', value)}
        />

        <Select
          label={labels?.billingType}
          options={billingTypeOptions}
          value={filters?.billingType}
          onChange={(value) => onFilterChange('billingType', value)}
        />

        <Select
          label={labels?.client}
          options={clientOptions}
          value={filters?.client}
          onChange={(value) => onFilterChange('client', value)}
          searchable
        />

        <Input
          label={labels?.dateFrom}
          type="date"
          value={filters?.dateFrom}
          onChange={(e) => onFilterChange('dateFrom', e?.target?.value)}
        />

        <Input
          label={labels?.dateTo}
          type="date"
          value={filters?.dateTo}
          onChange={(e) => onFilterChange('dateTo', e?.target?.value)}
        />

        <Input
          label={labels?.search}
          type="text"
          placeholder="INV-2024-001"
          value={filters?.search}
          onChange={(e) => onFilterChange('search', e?.target?.value)}
        />
      </div>
      <div className="flex justify-end mt-4">
        <Button
          variant="outline"
          iconName="RotateCcw"
          iconPosition="left"
          onClick={onReset}
        >
          {labels?.reset}
        </Button>
      </div>
    </div>
  );
};

export default InvoiceFilters;